import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { LoadingBar } from '@gem/ui-kit';

import { Group } from 'APP/store/Groups/Group';
import Entities from 'STORE';

import { ChatInfo } from './ChatInfo/ChatInfo';
import { DefaultHeaderActions } from './DefaultHeaderActions/DefaultHeaderActions';
import styles from './styles.m.css';

interface IDefaultHeaderProps {
  group: Group;
}

export const DefaultHeader: FC<IDefaultHeaderProps> = observer(({ group }) => {
  if (!group) {
    return null;
  }

  return (
    <div
      className={styles.container}
      data-test="chat-header"
    >
      <ChatInfo group={group} />
      <DefaultHeaderActions group={group} />
      <LoadingBar
        className={styles.loadingBar}
        loading={Entities.GroupsStore.activeGroup?.messagesStore.isLoading || false}
      />
    </div>
  );
});
